export const loadInbounds = async () =>{
    return new Promise ((resolve, reject)=>{
        const host = window.location.href;
        var telefonoM = "";
         // Cargamos los inbounds en Coche
         if(host.indexOf('segurosdecoche.mapfre.es/agr') > -1){
           if(host.indexOf('utm_source=kelisto') > -1){
             telefonoM = "911981752";
           }else if(host.indexOf('utm_source=arpem') > -1){
             telefonoM = "911981806";
           }else if(host.indexOf('utm_source=acierto') > -1){
             telefonoM = "911981736";
           }else if(host.indexOf('utm_source=rastreator') > -1){
             telefonoM = "911233455";
           }else if(host.indexOf('utm_source=kelisto') == -1 && host.indexOf('utm_source=arpem') == -1 && host.indexOf('utm_source=acierto') == -1 && host.indexOf('utm_source=rastreator') == -1){
            telefonoM = "911985471";
           }
         }
      
        // Cargamos los inbounds en Moto
        if(host.indexOf('segurosdemoto.mapfre.es/agr') > -1){
            if(host.indexOf('utm_source=arpem') > -1){
                telefonoM = "911981775";
            }else if(host.indexOf('utm_source=acierto') > -1){
                telefonoM = "911981744";
            }else if(host.indexOf('utm_source=rastreator') > -1){
                telefonoM = "911236269";
            }else if(host.indexOf('utm_source=arpem') == -1 && host.indexOf('utm_source=acierto') == -1 && host.indexOf('utm_source=rastreator') == -1){
                telefonoM = "919036797";
            }
        }
        // Cargamos los inbounds en Hogar
        if(host.indexOf('segurosdehogar.mapfre.es/agr') > -1){
            if(host.indexOf('utm_source=rastreator') > -1){
                telefonoM = "911237638";
            }else if(host.indexOf('utm_source=rastreator') == -1){
                telefonoM = "919036787";
            }
        }
    
        resolve(telefonoM);
    })

}

